module.exports = __webpack_public_path__ + "static/media/manta.df8104c7.svg";